/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export default class EnumMapper {

    public static getI18Key(enumTypeName: string, value: any): string {

        const valueKey = EnumMapper.getEnumKey(enumTypeName, value);
        const result = `enumerators:${enumTypeName}.${valueKey}`;

        return result;
    }

    public static getEnumKey(enumTypeName: string, value: any): string {
        switch (enumTypeName.toLowerCase()) {
            case "filetype":
                return EnumMapper.fileType(value);

           default:
               return value+"";
        }
    }
   private static fileType(value: unknown): string {
       switch (value) {
           case 1:
               return "csv";

           case 2:
               return "xlsx";

           case 3:
               return "xml";

           case 4:
               return "json";

           default:
               return value+"";
       }
    }

}
